module.exports = __webpack_public_path__ + "static/media/boleta_demo.0b5a61c1.png";